import { TablePaginationConfig } from 'antd'
import { paginationDefault } from 'shared/model/paginationDefault'

import { useSearchParams } from 'react-router-dom'

import { getOffset } from '../../pagination/offset'

const pageParam = 'page'
const limitParam = 'limit'

export function usePaginationQuery() {
  const [searchParams, setSearchParams] = useSearchParams()

  const page = searchParams.get(pageParam) || paginationDefault.page
  const limit = searchParams.get(limitParam) || paginationDefault.limit

  const set = (key: string, value: string) => {
    searchParams.set(key, value)
    setSearchParams(searchParams)
  }

  const setPage = (value: string) => {
    set(pageParam, value)
  }
  const setView = (value: string) => {
    if (limit === value) {
      return
    }
    set(limitParam, value)
  }

  const onChangeConfig = (config: TablePaginationConfig) => {
    setPage(String(config.current || 1))

    setView(String(config.pageSize || 1))
  }

  const paginationConfig: TablePaginationConfig & { offset: string } = {
    current: Number(page),
    showSizeChanger: true,
    pageSize: Number(limit),
    offset: String(getOffset(Number(page), Number(limit))),
  }

  return { setPage, setView, paginationConfig, onChangeConfig }
}
